import React from 'react';

const VariantSelect = ({ product, handleVariantSelection }) => {
    const selectId = `variant-select-${product.id}`;
    const availableOptionsCount = product.variants.length;
    
    return (
        <div className='variant-select-container'>
            <label 
                htmlFor={selectId}
                className='sr-only'
            >
                Select product variant
            </label>
            
            <select
                id={selectId}
                className='headless-card-variant-select headless-dropdown light'
                onChange={(e) => handleVariantSelection(JSON.parse(e.target.value))}
                aria-label='Choose product option'
                aria-describedby={`${selectId}-description`}
                required
            >
                <option value='' disabled>
                    Select an option
                </option>
                {product.variants.map((variant) => (
                    <option 
                        key={variant.id} 
                        value={JSON.stringify(variant)}
                        aria-label={`${variant.option}`}
                    >
                        {variant.option}
                    </option>
                ))}
            </select>
            
            <span 
                id={`${selectId}-description`}
                className='sr-only'
            >
                Choose from {availableOptionsCount} available product variants
            </span>

            <div 
                className='variant-select-error sr-only' 
                role='alert'
                aria-live='polite'
            ></div>
        </div>
    );
};

export default VariantSelect;
